import React, { useContext, useEffect, useState, useRef } from 'react';
import { withRouter, NavLink as Link } from 'react-router-dom';

import { Card } from 'src/components';
import { MerchantProfileContext } from 'src/context/merchant-profile-context';
import {
  businessCashAdvanceNoQualifyRoute,
  businessCashAdvancePreApprovedRoute,
  businessCashAdvanceTopUpCalculationRoute,
} from 'src/routing/routes';
import { OfferContext } from 'src/context/offer-context';
import TealiumEvents from 'src/helpers/tealium-events';
import HeaderNav from '../../header-nav/header-nav';

import './get-financed.scss';

import MiniAppEvents from 'src/helpers/miniapp-events';

export const moreInfoForFundingURL =
  'https://www.vodacombusiness.co.za/business/solutions/fund-my-business';
export const applyForFundingURL = 'https://vodalend.vodacombusiness.co.za/GetStarted?cid=undefined';
const BCAGetFinanced = () => {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const { merchant } = useContext(MerchantProfileContext);
  const { offers, isBCATopUp } = useContext(OfferContext);
  const [isPreApproved, setIsPreApproved] = useState(false);
  const [, setIsActive] = useState(false);
  const topOfPage = useRef('top');

  useEffect(() => {
    TealiumEvents.getFinancedPageLoadNewStyle();

    if (topOfPage.current) {
      topOfPage.current.scrollIntoView(false);
    }
  }, []);

  useEffect(() => {
    if (offers?.offerDetails?.CurrentBalance > 0) {
      setIsActive(true);
    } else if (offers?.offerDetails?.QualificationStatus === 1) {
      setIsPreApproved(true);
    }
  }, [offers]);

  return (
    <div className="BCAGetFinanced" data-testid="BCAGetFinanced">
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="Get Financed"
      >
        <h1 className="page-title" ref={topOfPage}>
          Finance options
        </h1>
        <div className="page-description">
          Whether you need to fund moving into a bigger office, buy equipment or property or just to
          get the cash flow you need to act quickly, we can make it happen.
        </div>
        <div className="card-container">
          <Card
            className={'offer-card fund-business-card ' + (!inMiniProgram ? '' : 'card-miniapp')}
          >
            <div className="columns is-multiline is-mobile">
              <div className="column is-one-third image-container"></div>
              <div className="column is-two-thirds details-container">
                <div className="text-container">
                  <p className="offer-title">Fund your business</p>
                  <p className="offer-subtitle">Finance options - 3 to 12 months</p>
                  <br />
                  <p>
                    If your South African business makes R500,000 or more a year and has operated
                    for at least 12 months...
                    <br />
                    {!inMiniProgram && (
                      <a
                        automationid="BCA_Link_GetFinancedFundMoreInfo"
                        className="is-red-text-link"
                        href={moreInfoForFundingURL}
                        onClick={() =>
                          TealiumEvents.getFinancedFundMeMoreInfo(moreInfoForFundingURL)
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        More info...
                      </a>
                    )}
                  </p>
                </div>
                <div className="button-container">
                  {!inMiniProgram && (
                    <a
                      automationid="BCA_Link_GetFinancedFundMoreInfo"
                      className="view-more"
                      href={applyForFundingURL}
                      onClick={() => TealiumEvents.getFinancedClickBTAApplyNow(applyForFundingURL)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Apply now
                    </a>
                  )}
                </div>
              </div>
            </div>
          </Card>

          <Card className="offer-card bca-card">
            <div className="columns is-multiline is-mobile">
              <div className="column is-one-third image-container">
                {isPreApproved && (
                  <div automationid="BCA_Div_GetFinancedPreApprovedLabel" className="pre-approved">
                    Pre-approved
                  </div>
                )}
              </div>
              <div className="column is-two-thirds details-container">
                <div className="text-container">
                  <p className="offer-title">Business cash advance</p>
                  <p className="offer-subtitle">Flexible repayments from your POS device</p>
                  <br />
                  <p>
                    Perfect for registered VodaPay merchants that earn R3 000 a month with a 3 month
                    record...
                  </p>
                </div>
                <div className="button-container">
                  {isPreApproved ? (
                    <Link
                      automationid="BCA_Link_GetFinancedBCAApplyNow"
                      className="view-more"
                      exact
                      to={
                        isBCATopUp
                          ? businessCashAdvanceTopUpCalculationRoute
                          : businessCashAdvancePreApprovedRoute
                      }
                      onClick={() =>
                        TealiumEvents.getFinancedClickBCAApplyNow(
                          businessCashAdvancePreApprovedRoute,
                        )
                      }
                    >
                      Apply now
                    </Link>
                  ) : (
                    <Link
                      automationid="BCA_Link_GetFinancedBCAMoreInfo"
                      className="view-more"
                      exact
                      to={
                        isBCATopUp
                          ? businessCashAdvanceTopUpCalculationRoute
                          : businessCashAdvanceNoQualifyRoute
                      }
                      onClick={() =>
                        TealiumEvents.getFinancedClickBCAApplyNow(businessCashAdvanceNoQualifyRoute)
                      }
                    >
                      Apply now
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </div>
      </HeaderNav>
    </div>
  );
};

BCAGetFinanced.propTypes = {};

BCAGetFinanced.defaultProps = {};

export default withRouter(BCAGetFinanced);
